import { magnificPopupIframe, magnificPopupInline, magnificPopupSingleImage, magnificPopupGalleryImage } from './popups'
import { basicSlider } from './sliders';
import { linksCustomization, scrollTo, responsiveTables, teamToggles } from './misc';
import setScrollBarWidth from 'set-scrollbar-width';  // Use with the Tailwind Container Break Out extension.

/* Flexible Content */
import accordion from '../../templates/blocks/accordion';
import featuredSlider from '../../templates/blocks/featured-slider';
import imageCarousel from '../../templates/blocks/image-carousel';


function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}



/* *********************** */
/* Start all the functions */
/* *********************** */
window.onload = function() {
	// Init
	consoleMessage()
	usingJS()
	setScrollBarWidth()
	linksCustomization()
	scrollTo()
	responsiveTables()

	// Popups
	magnificPopupIframe()
	magnificPopupInline()
	magnificPopupSingleImage()
	magnificPopupGalleryImage()

	// Sliders
	basicSlider()
  imageCarousel()
  featuredSlider()

	// Flexible Content
	accordion()
  //teamToggles()
}



jQuery(document).ready(function ($) {
	ajax: {
		/**
		 * Detects the "Search & Filter" plugin ajax call and re-starts "Magnific popup".
		 */
		$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
			magnificPopupIframe()
			magnificPopupInline()
			magnificPopupSingleImage()
			magnificPopupGalleryImage()
		});
	}
});

